import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { useFormikContext } from 'formik';
import type { PaymentFormValues } from 'Src/types/payment';
import { t } from 'Src/i18n';
import { PaymentFormikInput } from 'Components/widgets/payment-info/paymentFormik';
type Props = {
  paymentProvider: PaymentProvider;
  requiredRule: () => boolean;
  shouldSubmitFormOnPaymentChosen: boolean;
};
export const PaymentMethodsCardListPaymentProvider = ({
  paymentProvider,
  requiredRule,
  shouldSubmitFormOnPaymentChosen,
}: Props) => {
  const formik = useFormikContext<PaymentFormValues>();
  return (
    <div className="mt-20 flex flex-col">
      <span className="text-14">{t('booking.banking.paymentProvider.creditCard.cardList')}</span>
      <div>
        {/* /!\ important to keep these hidden fields for validation purpose */}
        <PaymentFormikInput type="hidden" name="paymentProviderId" validate={requiredRule} />
        <PaymentFormikInput type="hidden" name="paymentMethodId" />
        <PaymentFormikInput type="hidden" name="paymentConditionId" />
        <ul
          className={classnames('flex flex-wrap', {
            'formik-errored': formik.errors?.paymentMethodId,
          })}
        >
          {paymentProvider.paymentMethods.map((paymentMethod) => {
            const timePaymentCondition = paymentMethod?.timePaymentConditions?.find(
              (condition) => condition.id === paymentMethod.id,
            );
            const isPaymentMethodSelected =
              formik.values.paymentProviderId === paymentProvider.id &&
              formik.values.paymentMethodId === paymentMethod.id;
            return (
              <li
                key={paymentMethod.id}
                className={classnames('relative flex basis-1/4 flex-col justify-center', {
                  'my-10 h-45': !timePaymentCondition,
                  'basis-1/2 sm:basis-1/4': timePaymentCondition,
                })}
              >
                <img
                  data-testid={`PaymentMethodsCardList-${paymentMethod.id}`}
                  alt={paymentMethod.label || ''}
                  className={classnames('w-64 cursor-pointer rounded-2 p-10', {
                    'border-1 border-saffron': isPaymentMethodSelected,
                    'absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2':
                      !timePaymentCondition,
                    'static left-auto top-auto mx-auto transform-none': timePaymentCondition,
                    'border-1 border-red': formik.errors?.paymentMethodId,
                  })}
                  src={paymentMethod.image}
                  onClick={() => {
                    formik.setFieldValue('paymentProviderId', paymentProvider.id);
                    formik.setFieldValue('selectorPaymentProviderId', paymentProvider.selectorId);
                    formik.setFieldValue('paymentMethodId', paymentMethod.id);

                    if (shouldSubmitFormOnPaymentChosen) {
                      // should wait for validation to be done
                      setTimeout(formik.submitForm, 0);
                    }
                  }}
                />
                {timePaymentCondition && timePaymentCondition.chargePercentage > 0 ? (
                  <p className="m-0 text-center text-10 text-mediumGrey">
                    {t('booking.banking.paymentMethod.cardFeesLabel')}
                    <span className="block font-bold text-blueWave">
                      {t('booking.banking.paymentMethod.chargePercentage', {
                        charge_percentage: timePaymentCondition.chargePercentage,
                      })}
                    </span>
                  </p>
                ) : null}
                <span className="sr-only">{paymentMethod.label}</span>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};
